import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from './base-api';

export const bowtieApiReducerPath = 'bowtieApi';

export const emptyBowtieApi = createApi({
  reducerPath: bowtieApiReducerPath,
  baseQuery: (args, api, extraOptions) =>
    baseQueryWithReAuth(args, api, { ...extraOptions, apiSuffix: 'services/bowtie/v1' }),
  endpoints: () => ({}),
});
